import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {SeguroCobertura} from '../_models/seguro-cobertura';

@Injectable({
  providedIn: 'root'
})
export class SeguroCoberturaService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segurosCoberturas/';

  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as SeguroCobertura[] ) );
  }

  listadoPorIdSeguro( id: string ) {
    return this.httpClient.get( this.rutServicio + 'idSeguro/' + id ).pipe( map( res => res as SeguroCobertura[] ) );
  }



  listadoEnabled() {
    return this.httpClient.get( this.rutServicio + 'enabled/' ).pipe( map( res => res as SeguroCobertura[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as SeguroCobertura ) );
  }

  crear( regCrear: SeguroCobertura ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SeguroCobertura ) );
  }

  actualizar( regActualizar: SeguroCobertura ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }


  bulk( regActualizar: SeguroCobertura[] ) {
    regActualizar.map( ( s: SeguroCobertura ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServicio + 'bulk', regActualizar ).pipe( map( res => res as SeguroCobertura[] ) );
  }
}
